/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './consumable.reducer';

export const ConsumableDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const consumableEntity = useAppSelector(state => state.consumable.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consumableDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.consumable.detail.title">Consumable</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.consumable.id">Id</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.consumable.type">Type</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.type}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.consumable.name">Name</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.name}</dd>
          <dt>
            <span id="addedBy">
              <Translate contentKey="tinyMedicRestApp.consumable.addedBy">Added By</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.addedBy}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.consumable.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.consumable.active">Active</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.consumable.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.lastupdated}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="tinyMedicRestApp.consumable.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.unit}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.consumable.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.quantity}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.consumable.price">Price</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.price}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.consumable.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.consumable.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{consumableEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.consumable.group">Group</Translate>
          </dt>
          <dd>{consumableEntity.group ? consumableEntity.group.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.consumable.manufacturer">Manufacturer</Translate>
          </dt>
          <dd>{consumableEntity.manufacturer ? consumableEntity.manufacturer.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.consumable.catalog">Catalog</Translate>
          </dt>
          <dd>{consumableEntity.catalog ? consumableEntity.catalog.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/consumable" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/consumable/${consumableEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsumableDetail;
